
/**
 * These are the default fields in options, and will be combined with the type-specific options
 */
class FieldOptionsModel
{
	constructor()
	{
		this.view_access_roles = ko.observableArray();
		this.write_access_roles = ko.observableArray();
		this.conditional_access_rule_uuid = ko.observable(); /* Condition access rule */
		this.field_level_encryption = ko.observable(false);
		//this.expose_via_api = ko.observable(true); // Should the field be exposed by API
		this.expiry = ko.observable(); /* How long after saving is a value considered expired. Interval */
		this.data_retention = ko.observable(); /* How long to keep deleted values for. Interval */
		this.date_active = ko.observable(); /* When does the field become active */
		this.date_inactive = ko.observable(); /* When does the field become inactive */
		this.on_expiry_action = ko.observable('NONE'); /* DELETE, CLEAR, ANONYMIZE or NONE */
		this.enable_versioning = ko.observable(true);
		this.custom_validation_rule_uuid = ko.observable(null);
		this.linked_field_uuid = ko.observable(null);
		this.field_visibility_rules = ko.observableArray([]);
		this.value_formula_uuid = ko.observable();
		this.tags = ko.observableArray();

		this.is_protected = ko.observable();
	}
}

export default FieldOptionsModel;
